const RAG = {
  red: "bg-red-500/15 text-red-300 border-red-500/40",
  amber: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  green: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
};
const DOT = { red: "bg-red-500 animate-pulse", amber: "bg-amber-500", green: "bg-emerald-500" };
const RAG_TEXT = { red: "Overdue", amber: "Due soon", green: "Compliant" };

export const RagBadge = ({ status = "green", label, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded border px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider max-w-full whitespace-normal sm:whitespace-nowrap ${RAG[status]}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${DOT[status]}`} />
    {label || RAG_TEXT[status]}
  </span>
);

const RISK = { high: "red", medium: "amber", low: "green" };
export const RiskBadge = ({ risk, testid }) => <RagBadge status={RISK[risk] || "amber"} label={`${risk} risk`} testid={testid} />;

export const STAGE_LABELS = {
  issue_raised: "Issue Raised", risk_assessment: "Risk Assessment", work_order: "Work Order", assigned: "Assigned Engineer",
  repair_completed: "Repair Completed", verification: "Verification", closed: "Close Out",
};
export const STAGES = Object.keys(STAGE_LABELS);
